<template>
    <section>
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-content">
                        <center>
                            <button style="margin-top:3%" @click="$router.push('/home')" type="button" class="btn btn-w-m btn-info">Home</button>
                            <h1 style="font-size:50px;"><b>{{currentDate}}</b></h1></center>
                        <div class="row" style="margin-top:4%;">
                            <div class="col-md-6">
                                <div class="widget blue-bg p-lg text-center">
                                    <div class="m-b-lg">
                                        <h1 style="font-size:50px;">
                                            {{realTimeStatsData.total_orders}}
                                        </h1>
                                        <div class="row">
                                            <div class="col-md-5 text-right">
                                                <i class="fa fa-shopping-cart fa-3x"></i>
                                            </div>
                                            <div class="col-md-7 text-left">
                                                <h1 class="font-bold">Total Orders</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                            <div class="col-md-6">
                                <div class="widget yellow-bg p-lg text-center">
                                    <div class="m-b-lg">
                                        <h1 style="font-size:50px;">
                                            {{realTimeStatsData.pending_orders}}
                                        </h1>
                                        <div class="row">
                                            <div class="col-md-5 text-right">
                                                <i class="fa fa-clock-o fa-3x"></i>
                                            </div>
                                            <div class="col-md-7 text-left">
                                                <h1 class="font-bold">Pending Orders</h1>
                                            </div>
                                        </div>       
                                    </div>
                                </div>    
                            </div>
                            <div class="col-md-6">
                                <div class="widget red-bg p-lg text-center">
                                    <div class="m-b-lg">
                                        <h1 style="font-size:50px;">
                                            {{realTimeStatsData.total_complaints}}
                                        </h1>
                                        <div class="row">
                                            <div class="col-md-5 text-right">
                                                <i class="fa fa-exclamation-circle fa-3x"></i>
                                            </div>
                                            <div class="col-md-7 text-left">
                                                <h1 class="font-bold">Complaints</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                            <div class="col-md-6">
                                <div class="widget lazur-bg p-lg text-center">
                                    <div class="m-b-lg">
                                        <h1 style="font-size:50px;">
                                            {{parseFloat(realTimeStatsData.bucket_size).toFixed(2)}}
                                        </h1>
                                        <div class="row">
                                            <div class="col-md-5 text-right">
                                                <i class="fa fa-money fa-3x"></i>
                                            </div>
                                            <div class="col-md-7 text-left">
                                                <h1 class="font-bold">Bucket Size</h1>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>    
                            </div>                                                                                
                        </div>
                        <br>
                        <div class="row" style="margin-top:8%">
                            <button type="button" @click="getPreviousDateStats()" class="btn btn-w-m btn-info pull-left">Previous</button>
                            <button type="button" @click="getNextDayStats()" :disabled="previousDayCounter===0" class="btn btn-w-m btn-info pull-right">Next</button>                             
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageTitle from "../components/layout_components/PageTitle";
    export default {
        name: "RealTimeStats",
        components: {PageTitle},
        data(){
            return {
                currentDate:"",
                subscribedEvent:"",
                realTimeStatsData:{
                    bucket_size:0,
                    pending_orders:0,
                    total_complaints:0,
                    total_orders:0
                },
                previousDayCounter:0
            }
        },
        mounted: function() {
            this.currentDate= new Date().toDateString();
            this.subscribe();
            $("#side-menu").hide();
            $("nav").hide();
            $("#page-wrapper").css("margin-left","0px")
            $(".footer").hide();
        },
        beforeDestroy() {
            const self = this;
            window.removeEventListener('real-time-stats', self.subscribedEvent.close());
            $("#side-menu").show();
            $("nav").show();
            $("#page-wrapper").css("margin-left","70px")
            $(".footer").show();
        },
        methods:{
            subscribe: function(){
                this.subscribedEvent = new EventSource(this.$store.state.mainAppURL + 'restaurants/real_time_stats');
                let self = this
                this.subscribedEvent.addEventListener("real-time-stats", function(event) {
                    self.realTimeStatsData= JSON.parse(event.data);
                });
            },
            getPreviousDateStats: function(){
                this.subscribedEvent.close();
                this.previousDayCounter= this.previousDayCounter-1;
                this.$http.get(this.$store.state.mainAppURL + "restaurants/get_stats_of_date/" + this.getDate()).then(resp=>{
                    this.realTimeStatsData= resp.data;
                });
            },
            getNextDayStats: function(){
                this.previousDayCounter= this.previousDayCounter+1;
                if(this.previousDayCounter===0){
                    this.subscribe();
                }
                this.$http.get(this.$store.state.mainAppURL + "restaurants/get_stats_of_date/" + this.getDate()).then(resp=>{
                    this.realTimeStatsData= resp.data;
                });            
            },
            getDate: function(){
                const today = new Date()
                const otherDay = new Date(today)
                otherDay.setDate(otherDay.getDate() + this.previousDayCounter);
                this.currentDate= otherDay.toDateString();
                const formattedDate= moment(otherDay).format("YYYY-MM-DD");
                return formattedDate;
            }
        },

    }
</script>

<style scoped>

</style>